export default __webpack_public_path__ + "static/media/privacy.ae4380dd.svg";